import { TranslationObject } from '../i18n/translation';

const namespace = 'uhaRoles';

const translations: TranslationObject = {
  koordinator: {
    id: `${namespace}.koordinator`,
    nb: 'Koordinator',
    en: 'Coordinator',
  },
  underviser: {
    id: `${namespace}.underviser`,
    nb: 'Underviser',
    en: 'Tutor',
  },
};

export default translations;
